import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import Aux from './AuxContainer'

import queryString from 'query-string'
import agent from '../agent'
import AMLogo from '../assets/images/logo-white-text.png'
import AgencyProfileForm from '../components/agency/AgencyProfileForm'
import Modal from 'react-responsive-modal';
import { store, history } from '../store/configureStore'

//These options are for both genders
import heightOptions from '../data/height-options';
import complexions from '../data/complexions';
import eyeColours from '../data/eye-colours';
import waistSizes from '../data/waist-sizes';
import hairColours from '../data/hair-colours';
import ethnicities from '../data/ethnicities';
import weight from '../data/weight-options';
import hairLengths from '../data/hair-lengths';
//Female Adult Statistics Options
import bustSizes from '../data/bust-sizes';
import hipSizes from '../data/hip-sizes';
import femaleShoeSizes from '../data/female-shoe-sizes';
import femaleSuitSizes from '../data/female-suit-sizes';
import femaleDressSizes from '../data/female-dress-sizes';
import femaleBraSizes from '../data/female-bra-sizes';
//Male Adult Statistics Options
import chestSizes from '../data/chest-sizes';
import collarSizes from '../data/collar-sizes';
import maleShoeSizes from '../data/male-shoe-sizes';
import maleSuitSizes from '../data/male-suit-sizes';
import insideLegOptions from '../data/inside-leg-options';
import outsideLegOptions from '../data/outside-leg-options';
//Kids Statistics Options
import kidsShoeSizes from '../data/kid-shoe-sizes';
import kidsClothingOptions from '../data/kid-clothing-options';


const Artist = ({representation, approveArtist, denyArtist, displayDetails}) => {
 
	const avatar_url = representation.artist.avatar_url || "http://via.placeholder.com/350x450"
	return (
		<div className="grid-x align-center">
			<div className="cell">
				<div className="artist-image">
					<img src={avatar_url} alt="Artist Image"/>
				</div>
				<div className="name">{representation.artist.first_name} {representation.artist.last_name}</div>
				<div className="age">{representation.artist.age_from} {representation.artist.age_to} years</div>
				<div className="gender">{representation.artist.gender}</div>
				<div className="actions">
					{
						representation.contactFlag == 'edit' &&
							(<a className="button secondary expanded" onClick={() => displayDetails(representation)}>Update/Edit Talent Profile</a>)
					}
					{
						// const updateURL = 'https://v2.auditionmagic.com/verify?token=' + token
						representation.successAction
							? representation.successAction == 'approved'
								? (<div>
										<p className="text-center">Confirmed</p>
									</div>)
								: (<p className="text-center">Denied</p>)
							: representation.contactFlag == 'no-edit' && (<div>
									<button className="button hollow success expanded" onClick={() => approveArtist(representation.id) }>Confirm</button>
									<button className="button hollow alert expanded" onClick={() => denyArtist(representation.id) }>Deny</button>
								</div>)
					}
				</div>
			</div>
		</div>
	)
}


class Agency extends Component {
	state = {
		status: '',
		action: '',
		showModal: false,
		primary: true,
		selected_one: {}
	}

	componentWillMount() {
		const { location, comp, list, one, approved, deny } = this.props
		const values = queryString.parse(location.search)
		console.log('agency-component', this.props)
		if (values.confirm) {
			
			const action = values.confirm == 'true' ? 'approved' : 'deny'
			const actionDispatch = values.confirm == 'true' ? approved : deny

			actionDispatch(values.representation_request_id, values.token).then( response => {
				const { isApproved } = this.props
				this.setAction(action, isApproved.success ? 'success' : 'error' )
				this.getAllRequest(values)
			})
			
		} else {
			this.getAllRequest(values)
		}
		console.log('componentWillMount', this.props)
	}

	componentDidMount() {
		console.log('componentDidMount', this.props)
	}

	approveArtist = (id) => {
		const { location, approved } = this.props
		const values = queryString.parse(location.search)
		this.props.approved(id, values.token, id)

		// agent.Agency.representationApprove(id, values.token).then( response => {
		
		// })

		
	}

	denyArtist = (id) => {
		const { location, deny } = this.props
		const values = queryString.parse(location.search)

		this.props.deny(id, values.token, id)
	}

	setAction(action, status) {
		this.setState({
			action: action,
			status: status
		})
	}

	getAllRequest(values) {
		const { comp, list, one } = this.props
		const { token, representation_request_id } = values

		return Promise.all([
			comp(token), 
			list(token, 'pending'), 
			one(representation_request_id, token)
		])
	}

	showMessage(name) {
		const {status, action} = this.state
		const { represented } = this.props

		if (!status && !action) { return <span></span> }

		const message = {
			approved: {
				success: (<span>Thank you, <b>{name}</b> is already confirmed</span>),
				error: (<span><b>{name}</b> is already confirmed</span>)
			},
			deny: {
				success: (<span>Thank you, <b>{name}</b> has been revered to freelance and is no longer associated with your company</span>),
				error: (<span> <b>{name}</b> is no longer associated with your company</span>)
			}
		}

		return message[action][status]
	}

	filterByRegion (obj, region) {
	    const selectedRegion = region;
	    return obj.map(items => {
				var name = items.values.filter(item => item.name && item.region === selectedRegion);
				name = name.length > 0 ? name[0].name : ''
				return {id: items.id, name: name, label: `${name} ${selectedRegion}`};
			})

	  }

	displayDetails = (agency, artist) => {
		console.log('displayDetails', agency, artist)
		history.push({
			pathname: '/agency/details/1',
			state: {
				agency: agency,
				artist: artist
			}
		})
	}

	displayDetails = (representation) => {
		console.log('displayDetails', representation)
		const agencyToken = new URLSearchParams(this.props.location.search).get('token')
		history.push({
			pathname: '/agency/details/' + representation.id,
			search: '?token=' + agencyToken,
			state: {
				representation: representation
			}
		})	
	}

	submit = (values, dispatch, props) => {
		const getFormData = (object, namespace) => Object.keys(object).reduce((formData, key) => {	
			let formKey = namespace ? `${namespace}[${key}]` : key
			formData.append(formKey, object[key])
			return formData
		}, new FormData());
		agent.Artist.updateProfile(values.artist.id, getFormData(values.artist, 'artist'))
			.then((k) => {
				//this.approveArtist(representation.id)
				this.setState({ showModal: true })
		})
	}

	render() {
		const { representation, represented, agencies, token } = this.props
		const { status, action } = this.state
		
		if (!representation || !represented || !agencies) {
			return (<div> Loading </div>)
		}
		var initialValues = {}
		var artistPhoto = {}
		this.state.primary ?
			initialValues = {
			    artist: {
			      first_name: represented.artist.first_name,
			      last_name: represented.artist.last_name,
			      gender: represented.artist.gender,
			      age_from: represented.artist.age_from,
			      age_to: represented.artist.age_to,
			      email: represented.artist.email,
			      mobile_number: represented.artist.mobile_number,
			      country: represented.artist.country,
			      state: represented.artist.state,
			      city: "",
			      id: represented.artist.id,
			      category: represented.artist.category,
			      birth_date: represented.artist.birth_date,
			      ageCategory: 'adult'
			    }
			  } : 
			initialValues = {
				artist: {
					first_name: this.state.selected_one.artist.first_name,
					last_name: this.state.selected_one.artist.last_name,
					gender: this.state.selected_one.artist.gender,
					age_from: this.state.selected_one.artist.age_from,
					age_to: this.state.selected_one.artist.age_to,
					email: this.state.selected_one.artist.email,
					mobile_number: this.state.selected_one.artist.mobile_number,
					country: this.state.selected_one.artist.country,
					state: this.state.selected_one.artist.state,
					city: '',
					id: this.state.selected_one.artist.id,
					category: this.state.selected_one.artist.category,
					birth_date: this.state.selected_one.artist.birth_date,
					ageCategory: 'adult'
				}
			}
		this.state.primary ?
			artistPhoto = represented.artist.photo || represented.artist.photo_thumb || represented.artist.avatar_url :
			artistPhoto = this.state.selected_one.artist.photo || this.state.selected_one.artist.photo_thumb || this.state.selected_one.artist.avatar_url

		const artist = represented.artist
		const updateURL = 'https://v2.auditionmagic.com/verify?token=' + token
		var representationFix = []
		representation.map((item, i) => {
			let newItem = { ...item, contactFlag: ((item.artist.email === null || item.artist.email === '') || 
				(item.artist.avatar === 'dummy.jpg' || item.artist.avatar === 'Dummy_Profile_Image.png'))
				? 'edit' : 'no-edit' }
			representationFix = [ ...representationFix, newItem ]
		})
		console.log('render-agency', initialValues, this.state.selected_one)
		const statOptions = [
			{label: 'Height',  name: 'height',  values: heightOptions, selected: null, gender: ''},
			{label: 'Complexion',  name: 'complexion',  values: complexions, selected: null, gender: ''},
			{label: 'Eye Colour',  name: 'eye_colour',  values: eyeColours, selected: null, gender: ''},
			{label: 'Waist Size',  name: 'waist_size',  values: waistSizes, selected: null, gender: ''},
			{label: 'Hair Colour',  name: 'hair_colour',  values: hairColours, selected: null, gender: ''},
			{label: 'Ethnicities',  name: 'ethnicities',  values: ethnicities, selected: null, gender: ''},
			{label: 'Weight',  name: 'weight',  values: weight, selected: null, gender: ''},
			{label: 'Hair Lengths',  name: 'hair_length',  values: hairLengths, selected: null, gender: ''},
			//Female
			{label: 'Bust Size',  name: 'bust_size',  values: bustSizes, selected: null, gender: 'female'},
			{label: 'Hip Size',  name: 'hip_size',  values: hipSizes, selected: null, gender: 'female'},
			{label: 'Shoe Size',  name: 'shoe_size',  values: this.filterByRegion(femaleShoeSizes, artist.statistics_region), selected: null, gender: 'female'},
			{label: 'Suit Size',  name: 'suit_size',  values: this.filterByRegion(femaleSuitSizes, artist.statistics_region), selected: null, gender: 'female'},
			{label: 'Dress Size', name: 'dress_size', values: this.filterByRegion(femaleDressSizes, artist.statistics_region), selected: null, gender: 'female'},
			{label: 'Bra Size',   name: 'bra_size',   values: this.filterByRegion(femaleBraSizes, artist.statistics_region), selected: null, gender: 'female'},
			//Male
			{label: 'Chest Size',  name: 'chest_size',  values: chestSizes, selected: null, gender: 'male'},	      
			{label: 'Collar Size',  name: 'collar_size',  values: collarSizes, selected: null, gender: 'male'},
			{label: 'Shoe Size',  name: 'shoe_size',  values: this.filterByRegion(maleShoeSizes, artist.statistics_region), selected: null, gender: 'male'},
			{label: 'Suit Size',  name: 'suit_size',  values: this.filterByRegion(maleSuitSizes, artist.statistics_region), selected: null, gender: 'male'},
			{label: 'Inside Leg',  name: 'inside_leg',  values: insideLegOptions, selected: null, gender: 'male'},
			{label: 'Outside Leg',  name: 'outside_leg',  values: outsideLegOptions, selected: null, gender: 'male'},
			//Kids
			{label: 'Kids Shoe Size', name: 'kids_shoe_size', values: this.filterByRegion(kidsShoeSizes, artist.statistics_region), selected: null, gender: 'kid'},
			{label: 'Kids Clothing', name: 'kids_clothing', values: this.filterByRegion(kidsClothingOptions, artist.statistics_region), selected: null, gender: 'kid'}
		];
		return (
			<Aux>
				<div id="agency-container">
				<header>
					<div className="grid-x">
						<div className="small-6 medium-3">
							<div className="logo-container">
								<img src={AMLogo} alt="Audition Magic Logo" />
							</div>
						</div>
					</div>
				</header>


					<div className="grid-x grid-padding-x align-center">
						<div className="cell small-12 medium-8 large-5">
							<div className="company-logo text-center">
									{
											agencies.logo_url
												? <img src={agencies.logo_url} alt="Agency Logo"/>
												: <h1>{agencies.name}</h1>
									}
							</div>

							<div className="grid-x grid-padding-x align-center basic-info">
								<div className="cell small-12 medium-6" data-equalizer-watch>
									<img src={artist.avatar_url} alt="Artist Image"/>
								</div>
								<div className="cell small-12 medium-6 artist-info">
									<div className="name"><b>{artist.first_name}</b> {artist.last_name}</div>
									<div className="role"><span className="gender">{artist.gender}</span> | Actor</div>
									<div className="age">{artist.age_from} - {artist.age_to} Years</div>
									<br/>
									<ul className="no-bullet statistics">
										{
											!artist.statistics && artist.statistics["ethnicities"] == '' &&
											(Object.keys(artist.statistics).map((stat,index) => {
												const statistic = statOptions.filter(k => k.name == stat && (k.gender == artist.gender || k.gender == ''));
												statistic.selected = statistic[0].values.find(j => artist.statistics[stat] === j.id)
												return (<li key={index}>
													<span className="stat-label">{statistic[0].label}</span>
													<span className="value">{statistic.selected && (statistic.selected.name)}</span>
												</li>)								
											}))
										}
									</ul>
								</div>
							</div>

						</div>
					</div>

					<div className="grid-x grid-padding-x align-center">
						<div className="cell small-6 medium-5">
							{
								artist.email === null || artist.email === '' ?
									<div className="cell small-12">
										<br/>
										<a className='button secondary expanded' onClick={e => this.displayDetails(agencies, artist)}>Update/Edit Talent Profile</a>
									</div> :
									<div className="cell small-12">
										<p className="header-message text-center lead">
											{
												this.showMessage(artist.first_name)
											}
										</p>
									</div>
							}
						</div>
					</div>


					<hr/>


					<div className="grid-x align-center">
						<div className="cell small-12 text-center">
							<p className="lead">Other Talent still waiting your confirmation of representation</p>
						</div>

						<div className="cell small-12 medium-9 pending-artist-list">
								<div className="grid-x grid-padding-x small-up-2 medium-up-3 large-up-4 align-center">

									{
										representationFix.map( item => 
										<Artist representation={item} approveArtist={this.approveArtist} 
											denyArtist={this.denyArtist} displayDetails={this.displayDetails} key={item.id}></Artist>
									)}

								</div>
						</div>
					</div>

				</div>
			</Aux>
		)
	}
}

const mapStateToProps = state => {
	return ({
		represented: state.agency.represented,
		token: state.agency.token,
		representation: state.agency.representation,
		agencies: state.agency.agencies,
		isApproved: state.agency.isApproved
		// ...state
	})
}

const mapDispatchToProps = dispatch => ({
	onLoad: payload =>
		dispatch({ type: 'AGENCY_PAGE', payload: payload}),
	comp: token =>
		dispatch({ type: 'AGENCY_DETAILS', payload: agent.Agency.agencyInfo(token) }),
	list: (token, status) =>
		dispatch({ type: 'REPRESENTATION_LIST', payload: agent.Agency.representationRequest(token, status) }),
	one: (id, token) =>
		dispatch({ type: 'REPRESENTED_ARTIST', payload: agent.Agency.representationArtist(id, token) }),
	approved: (id, token, artist_id) =>
		dispatch({ type: 'AGENCY_ARTIST_APPROVE', payload: agent.Agency.representationApprove(id, token), artist_id }),
	deny: (id, token, artist_id) =>
		dispatch({ type: 'AGENCY_ARTIST_DENY', payload: agent.Agency.representationDeny(id, token), artist_id })
})

export default connect(mapStateToProps, mapDispatchToProps)(Agency)







// WEBPACK FOOTER //
// ./src/containers/Agency.js